module.exports = __webpack_public_path__ + "img/9788958072522.ca20f893.jpg";